// Static sample data for the stakeholder rank-comparison table. Each row is one
// category with the rank (1 = highest priority) that each stakeholder group gave
// it. `spread` (highest rank − lowest rank across the groups) is derived, not
// stored, since it is fully determined by the ranks shown.


// Ranks a row assigned, in group order.

// Spread = gap between the highest and lowest rank across groups (0 = unanimous).


// Badge colour by how contested the ranking is:
//   <= 1 agreed (green), 2 mild (amber), >= 3 contested (red)
export const spreadLevel = (spread) => {
    if (spread <= 1) return 'low';
    if (spread <= 2) return 'medium';
    return 'high';
};

export const HEADER_TEXT = {
    title: "Alignment across all stakeholder groups",
    description: "Every group's rank order of the same categories. The Spread column highlights which categories are contested versus agreed upon."
}